import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useU2000AxiosAuthenticated from '../u2000Core/axios/U2000UseAxiosAuthenticated';
import { U2000HandleApiError } from '../u2000Core/axios/U2000HandleApiError';
import { useToast } from '../u2000Core/context/toast/U2000ToastContext';
import type { U2000AutoCompleteSearchResult } from '../u2000Core/types/U2000AutoCompleteSearchResult';
import { u2000ExtractAutoCompleteResults } from '../u2000Core/utils/u2000ExtractAutoCompleteResults';
import {
  doFindCustomer,
  luHandleAppiError,
  type U3120AutoCompletCriterias,
  type U3120FindCustomerItem,
} from './U3120Service';
import { NS } from './U3120';

/** Recherche client via POST /U3120/findCustomer (criteriaLookup BL-0058). */
export function useU3120FindCustomerHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation();
  const toast = useToast();

  const search = useCallback(
    async (criterias: U3120AutoCompletCriterias): Promise<U2000AutoCompleteSearchResult<U3120FindCustomerItem>> => {
      try {
        const response = await doFindCustomer(axios, criterias);
        return u2000ExtractAutoCompleteResults<U3120FindCustomerItem>(response.data);
      } catch (error: unknown) {
        const errorResult = U2000HandleApiError(error as Error, t, NS, luHandleAppiError);
        if (errorResult.genericErrors?.length) {
          errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
        }
        return { results: [], totalCount: 0, truncated: false };
      }
    },
    [axios, t, toast],
  );

  return { search };
}
